import { render, staticRenderFns } from "./QuickSMS.vue?vue&type=template&id=159f3670"
import script from "./QuickSMS.vue?vue&type=script&lang=js"
export * from "./QuickSMS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports